<template>
	<div class="page_content explore_entity_inside program degree_req" aria-label="Program Guide Degree Requirements">

    	<div class="row page-heading">
      		<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
        		<span class="module_icon  icon-list"></span>
        		<label v-if="formattedProgramGuide && formattedProgramGuide.title && formattedProgramGuide.title.length > 0" id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" :aria-label="'Program ' + formattedProgramGuide.title">
          			Program: {{formattedProgramGuide.title}} Pathways
        		</label>
        		<label v-else id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" :aria-label="'Program ' + formattedCareer.name">Program: {{formattedCareer.name}}</label>

						<b-popover target="programGuideTitle" triggers="hover" placement="top" class="title_popup" container="entityNameContainer">
							<div class="title_container">
							  <template v-if="formattedProgramGuide && formattedProgramGuide.title">
									Program: {{formattedProgramGuide.title}}
								</template>
								<template v-else>
									Program: {{formattedCareer.name}}
								</template>
							</div>
						</b-popover>
						<div id="entityNameContainer" class="title_container_popup"></div>
      		</div>

      		<template v-if="isWidget">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 btn_container" :id="'creditProgressPopup_' + programGuide.uuid">
              <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(programGuide)">
                <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
                  <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
                  <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
                  <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
                </b-progress>
              </b-btn>
            </div>
          </template>
          <template v-else>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 btn_container" v-if="showBackToResultButton">
							<!--
							<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
                <span class="btn_ic ic-back"></span>
                <span class="btn_txt"> {{ deCamelCase() }} </span>
              </b-btn>
							-->
              <span class="lnk_req_credit"
                v-if="showCalculateRequiredCredit && isStudentLogin && planningStream" :id="'creditProgressPopup_' + programGuide.uuid"
                @click="calculateCreditProgressClicked(programGuide)">
                <template v-if="isShowCourseProgressEnabled">
                  <b-btn style="width: 225px; padding: 0;">
                    <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                      <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                      <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                      <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                      <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                      <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                    </b-progress>
                  </b-btn>
                </template>
                <template v-else>
                  <b-btn style="width: 225px; padding: 0;">
                    <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                      <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                      <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                      <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                      <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                      <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                    </b-progress>
                  </b-btn>
                </template>
              </span>
        		</div>
          </template>
    	</div>


    	<div class="page_content_container">

        <div v-if="formattedProgramGuide && formattedProgramGuide.title">
          <program-guide-menu
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :returnTo="returnTo"
                :showBackToResultButton="showBackToResultButton"
                :active="'streams'"
                :isWidget="isWidget"
                :selected="selected">
            </program-guide-menu>
       	</div>

    		<div class="row pg_content">

    			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

					<div class="row pg_sec">

		          		<div class="col-12 sec_content">
										<div class="row">
		          				<div class="col-12 tbl_sec">

			                  <template v-if="isPathwaySelected">
													<div class="pg_win entity_info">

														<div class="pg_win_hd">
															<div class="ic_container">
																<span class="ic ic8-arrow-left2" aria-label="back" title="back to pathway list" @click="showAllPathways()"></span>
															</div>
															<div class="hd_txt">
																{{selectedPathway.title}}
															</div>
														</div>


														<div class="pg_win_content">
															<div class="row program-guide-section prog_detail-section" v-if="selectedPathway && selectedPathway.requirements">
																<div class="col-12 mid-panel" style="width: 100%; max-width: 100%; height: 100%; border: none;">
																	<div id="degreeRequirementsPage">
																		<div class="degreeRequirements pg_content_sec ace_sec_txt">
																			<div v-html="selectedPathway.requirements" ref="reqParentDiv"></div>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else class="msg_no_data empty_pattern ace_sec_txt" aria-label="No data available for this program guide">
																Requirements for this pathway are not available.
															</div>

														</div>
													</div>
			                  </template>

									    </div>

		            		</div>
		          		</div>
		          	</div>

        		</div> <!-- .content_mid_panel -->

						<!--
        		<div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 content_rgt_panel">

							<div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
          				<program-guide-summary></program-guide-summary>

          				<program-guide-recommendations
              				:cipCode="formattedProgramGuide.cipCode"
              				:programGuideCode="formattedProgramGuide.code"
              				:type="formattedProgramGuide.type"
                      :returnTo="returnTo"
                      :showBookmarks="true">
      						</program-guide-recommendations>
        			</div>

	    			</div>
						-->
						<!-- .content_rgt_panel -->

        	</div> <!-- .pg_content -->
          <template v-if="showCreditProgressPopup">
            <explore-program-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId"
                :is-widget="isWidget"
                :selected="Number(selected)">
            </explore-program-credit-progress>
          </template>
		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>


	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideRecommendations from './ProgramGuideRecommendations'
import ProgramGuideSummary from './ProgramGuideSummary'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'

export default {
  name: 'program-guide-pathway-detail',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer', 'selectedPathway'],
  components: {
    ProgramGuideMenu,
    ProgramGuideRecommendations,
    ProgramGuideSummary,
    ExploreProgramCreditProgress
  },
  data: () => {
    return {
      RECOMMENDATION_TERM_LIMIT: 5,
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      isPathwaySelected: true,
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      progress: {}
    }
  },

  async mounted () {
    this.loadDataForProgramGuideDegreeRequirements()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadLogDashboardActivity',
      'loadProgramCreditProgress'
    ]),
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    async loadDataForProgramGuideDegreeRequirements () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        // return this.$router.push({ name: returnTo })
      }
      if (!this.selectedPathway) {
        let routerParams = {
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          returnTo: 'exploreProgramGuideResults',
          showBackToResultButton: true,
          isWidget: this.isWidget,
          selected: this.selected
        }
        let queryParam = {
          returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
        }
        this.$router.push({ name: 'programGuideStreams', params: routerParams, query: queryParam })
      }
      // load credit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: programGuide.uuid, recalculate: false})
      this.loadLogDashboardActivity({action: 'viewProgramPathways', page: 'programPathways', link: '', programCipCode: cipCode})
      this.bindClickEventOnSubCategory()
    },
    bindClickEventOnSubCategory () {
      let parentElem = this.$refs['reqParentDiv']
      let elems = $(parentElem).find('.pg_sec_head')
      if (elems && elems.length > 0) {
        for (let i = 0; i < elems.length; i++) {
          let elem = elems[i]
          let reqCode = $(elem).attr('id')
          $(elem).first().click(() => {
            this.updatePageSecCssClass(reqCode)
          })
        }
      }
    },
		updatePageSecCssClass (pgSectionId) {
			let isActiveClass = $('#accordionCrdContent_' + pgSectionId).hasClass('active')
			if (isActiveClass) {
				$('#' + pgSectionId).removeClass('active')
				$('#accordionCrdContent_' + pgSectionId).removeClass('active')
				$('#accordionCrdContent_' + pgSectionId).css('display', 'none')
			} else {
				$('#' + pgSectionId).addClass('active')
				$('#accordionCrdContent_' + pgSectionId).addClass('active')
				$('#accordionCrdContent_' + pgSectionId).css('display', 'block')
			}
		},
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'go to program results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    showAllPathways() {
      let routerParams = {
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type,
        returnTo: 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.isWidget,
        selected: this.selected
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
      }
      this.$router.push({ name: 'programGuideStreams', params: routerParams, query: queryParam })
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'planningStream': state => state.dashboard.planningStream
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
	.link {
		cursor: pointer;
		color: #303030;
		padding: 3px 0px;
	}
	.link:hover {
		color: #b78b10;
	}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuidePathwayDetail.vue